module.exports = __webpack_public_path__ + "img/codigoazul.160a8f3e.gif";